/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import { breakpointCodes } from 'rp-mq-breakpoints';

const { EXTRA_NARROW, NARROW, MEDIUM, WIDE, EXTRA_WIDE } = breakpointCodes;
const [ICON_SMALL, ICON_MEDIUM, ICON_LARGE] = [24, 32, 64];

/**
 * Function, that returns proper icon size regarding on breakPointCode
 * @param breakPointCode
 * @returns {*|number}
 */
const getIconSize = (breakPointCode) => {
    switch (breakPointCode) {
    case EXTRA_NARROW:
        return ICON_SMALL;
    case NARROW:
    case MEDIUM:
    case WIDE:
        return ICON_MEDIUM;
    case EXTRA_WIDE:
        return ICON_LARGE;
    default:
        return ICON_SMALL;
    }
};

/**
 * Function, that sets proper display to block
 * @param container
 * @param section
 * @param label
 * @param breakPointCode
 * @returns {boolean}
 */
const normalizeHeadingDisplay = (container, section, label, breakPointCode) => {
    if (!(container && section && label)) {
        return false;
    }

    const iconSize = getIconSize(breakPointCode);
    const computedStyle = getComputedStyle(container);

    let containerWidth = container.clientWidth;
    containerWidth -= parseFloat(computedStyle.paddingLeft) +
        parseFloat(computedStyle.paddingRight);

    [section, label].forEach((element) => {
        if (element.offsetWidth + iconSize >= containerWidth) {
            element.style.display = 'block'; // eslint-disable-line no-param-reassign
        }
    });

    return true;
};

export { normalizeHeadingDisplay as default };



// WEBPACK FOOTER //
// ./src/js/News/components/NewsStory/utils/normalizeHeadingDisplay.js